export default __webpack_public_path__ + "static/media/하나.e2e28c26.svg";